import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  isRefreshingToken:boolean=false;

  constructor(public auth:AuthService, public http:HttpClient) { }

  intercept(req, next){
    let tokenizedRequest;

    if(this.auth.loggedIn.value==true){
      if(!this.isRefreshingToken && this.auth.getToken()!=null){
        this.isRefreshingToken=true;
        this.auth.refreshToken().subscribe();
        setTimeout(() => {
          this.isRefreshingToken=false;
        });
      }

      tokenizedRequest= req.clone({
      setHeaders: {
        Authorization: `Bearer ${this.auth.getToken()}`
      }});

    }else{
      tokenizedRequest=req;
    }

    return next.handle(tokenizedRequest);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/token-interceptor.service.ts